import { useMutation } from '@common-fe/common-fe';
import _ from 'lodash';

import { api } from '@/api';
import { RiskControlOptions } from '@/common/constants';
import { API_URL } from '@/dtos';

interface Payload {
  amount: number;
  toleranceModel: RiskControlOptions;
}
interface Params {
  isEmptyPortfolioMode?: boolean;
}
export const useSwitchToManagedQuery = (param?: Params, onSuccess?: () => void, onError?: () => void) => {
  const { mutateAsync, isLoading, isError, isSuccess } = useMutation(
    (payload: Payload) =>
      api.patch(API_URL.INVESTORS_INVESTMENT_MODELS, {
        new_investment_type: 'MANAGED',
        risk_tolerance_model: payload.toleranceModel,
        investment_amount: param?.isEmptyPortfolioMode ? _.floor(payload.amount, 2) || null : null,
      }),
    {
      onSuccess: () => {
        if (onSuccess) onSuccess();
      },
      onError: () => {
        if (onError) onError();
      },
    }
  );

  return {
    handleSave: mutateAsync,
    isLoading,
    isSuccess,
    isError,
  };
};
export default useSwitchToManagedQuery;
